import { restApi } from '../../../../../../../services/api';
import { PaginatedResponse } from '../../../../../../../types/request.types';
import { QueryKeysAndFnOptions } from '../useQueryKeysAndFnToCache.types';

interface GenerateQueryKeysAndFnToPaginatedEndpointParams<
  T = unknown,
  P = Record<string, unknown>,
> {
  url: string;
  fnToSaveData: (data: T[]) => Promise<void>;
  priority: number;
  params?: Omit<P, 'limit' | 'skip'>;
}

const ITEMS_PER_PAGE = 50;

export const generateQueryKeysAndFnToPaginatedEndpoint = async <T, P = unknown>({
  fnToSaveData,
  url,
  params,
  priority,
}: GenerateQueryKeysAndFnToPaginatedEndpointParams<T, P>) => {
  const response = await restApi.get<PaginatedResponse<unknown>>(url, { ...params, limit: 1 });

  if (!response.ok || !response.data) {
    throw response.data;
  }

  const limit = response.data.count;

  const queryKeysAndFn: QueryKeysAndFnOptions = Array.from(
    { length: Math.ceil(limit / ITEMS_PER_PAGE) },
    (_, index) => {
      const newParams = { ...params, limit: ITEMS_PER_PAGE, skip: index * ITEMS_PER_PAGE };

      return {
        priority,
        useReactQuery: false,
        queryKey: [url, undefined, newParams],
        queryFn: async () => {
          const response = await restApi.get<PaginatedResponse<T>>(url, newParams);

          if (!response.ok || !response.data) {
            throw response.data;
          }

          await fnToSaveData(response.data.data);
        },
      };
    },
  );

  return queryKeysAndFn;
};
